"use strict";
/** Получить домен окружения */var getEnvironDomain=function(){return window&&window.location&&window.location.hostname.split(".").slice(-2).join(".")};exports.getEnvironDomain=getEnvironDomain;
